// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IUf2","rootInner":"styles_rootInner__1NMvF","parentsContent":"styles_parentsContent__2oXuc","tablet":"styles_tablet__3oT2_"};